/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ message: NonNullable<unknown> }} Case_Contact_Save_ErrorInputs */

const en_case_contact_save_error = /** @type {(inputs: Case_Contact_Save_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Could not save the contact: ${i?.message}`)
};

const pt_br2_case_contact_save_error = /** @type {(inputs: Case_Contact_Save_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Não foi possível salvar o contato: ${i?.message}`)
};

/**
* | output |
* | --- |
* | "Could not save the contact: {message}" |
*
* @param {Case_Contact_Save_ErrorInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_contact_save_error = /** @type {((inputs: Case_Contact_Save_ErrorInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Contact_Save_ErrorInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_contact_save_error(inputs)
	return pt_br2_case_contact_save_error(inputs)
});